import { useState, useEffect, useMemo } from "react";
import { BrowserRouter as Router, Link, Route, Switch, Redirect, useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ReadCookie } from "../utils/readCookie";
import NotFound from "../screens/NotFound/NotFound";
import Login from "../screens/Login/Login";
import "./main.css";
import { Modal } from "antd";
import { routesArr } from "./routesData.js";
import { getUserType } from "../redux/actions/userType.action.js";
import { getMenu } from "../redux/actions/menus.js";
import PageLayout from "./pageLayout.js";
import Loader from "react-loader-spinner";
import * as ScreenComponents from '../screens/index.js'
import Unauthorized from "../screens/Unauthorized/Unauthorized.js";

export default function Routes() {
	const { menus } = useSelector((state) => state);
	const history = useHistory();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [modalValue, setModalValue] = useState(null)
	const dispatch = useDispatch();
	const userToken = ReadCookie("token");

	const params = new URLSearchParams(window.location.search);
	const redirectRaw = params.get('redirect');
	const redirectPath = redirectRaw ? decodeURIComponent(redirectRaw) : '';

	const _routesArr = useMemo(() => {
		if (!menus.payload) return [];

		const routes = [];

		menus.payload.forEach(x => {
			x.children.forEach(l1 => {
				l1.children.forEach(l2 => {
					if (l2.col_runtime_name) {
						routes.push({
							path: l2.col_runtime_name.startsWith('/') ? l2.col_runtime_name : '/' + l2.col_runtime_name,
							screen: ScreenComponents[l2.component_name],
							isReportScreen: l2?.is_report,
							menuObj: l2
						});
					}

					if (l2.children?.length) {
						l2.children.forEach(l3 => {
							if (l3.col_runtime_name) {
								routes.push({
									path: l3.col_runtime_name.startsWith('/') ? l3.col_runtime_name : '/' + l3.col_runtime_name,
									screen: ScreenComponents[l3.component_name],
									isReportScreen: l3?.is_report,
									menuObj: l2
								});
							}
						});
					}
				});
			});
		});

		return routes;
	}, [menus, routesArr]);

	useEffect(() => {
		if (userToken && menus.length === 0) {
			dispatch(getUserType(userToken));
			dispatch(getMenu(userToken));
		}
	}, [userToken, menus]);

	const handleOk = () => {
		setIsModalVisible(false);
	};

	useEffect(() => {
		if (modalValue === "t") {
			setIsModalVisible(true);
		}
	}, [modalValue]);

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const displayModal = (() => {
		return (
			<Modal title="Change Your Password"
				visible={isModalVisible}
				onOk={handleOk}
				onCancel={handleCancel}
			>
				<p>Please change your password.</p>
				<Link style={{ color: "#0d6efd", textDecoration: "underline" }} to={"forget-password"} onClick={() => handleCancel()}
				>{"Click Here to reset Password"}</Link>
			</Modal >
		)
	})

	if (menus.loading) {
		return (
			<div
				style={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					marginTop: "20%",
				}}
			>
				<div style={{ width: "100px", height: "100vh" }}>
					<Loader type="TailSpin" color="gray" height={60} width={60} />
				</div>
			</div>
		)
	}

	return (
		<>
			<Router history={history}>
				{userToken && modalValue ? displayModal() : ""}
				<Switch>
					<Route
						exact
						path="/login"
						render={() => {
							if (userToken) {
								if (redirectPath) {
									return <Redirect to={redirectPath} />
								} else {
									// rights for sales target report person redirection
									const _rights = _routesArr.length ? _routesArr.find(x => x.menuObj.col_menu_id === 1356) : {}
									if (_rights?.menuObj?.can_view) {
										return <Redirect
											to={{
												pathname: "/sales-target-report-saleperson",
												state: { referrer: 'login' }
											}}
										/>
									} else {
										return <Redirect to="/" />
									}
								}
							} else {
								return <Login setModalValue={setModalValue} modalValue={modalValue} />;
							}
						}}
					/>
					<InnerScreenRenderer
						routes={_routesArr}
						userToken={userToken}
						modalValue={modalValue}
					/>
				</Switch >
			</Router >
		</>
	);
}

const InnerScreenRenderer = ({ routes, userToken, modalValue }) => {
	const location = useLocation();
	const currentPath = location.pathname;
	const isAuthenticated = ReadCookie("token");
	const redirectPath = encodeURIComponent(window.location.pathname + window.location.search)

	if (!isAuthenticated) {
		return <Redirect to={'/login' + `?redirect=${redirectPath}`} />
	}

	const normalizedPath = currentPath.replace(/(\/[^/]+\/edit)\/\d+$/, "$1/:id");

	if (currentPath === '/control-sheet-advanceship') {
		const ControlSheetAdvanceShip = ScreenComponents.ControlSheetAdvanceShip
		return (
			<PageLayout>
				<Route
					path={currentPath}
					exact
					render={() => (
						<ControlSheetAdvanceShip
							userRights={{}}
							token={userToken}
						/>)}
				/>
			</PageLayout>
		);
	}

	const matchedRoute = useMemo(() => {
		return routes.find((r) => r.path === normalizedPath);
	}, [normalizedPath, routes]);

	if (!matchedRoute || !matchedRoute?.screen) return <PageLayout><NotFound /></PageLayout>;

	if (!matchedRoute?.menuObj?.can_view) return <PageLayout><Unauthorized /></PageLayout>;

	const Screen = matchedRoute.screen;

	if (matchedRoute.isReportScreen) {
		return <Route
			path={matchedRoute.path}
			exact
			render={() => (
				<Screen
					userRights={matchedRoute.menuObj}
					token={userToken}
					{...(matchedRoute.path === "/sales-target-report-saleperson" ? modalValue : {})}
				/>)}
		/>
	}

	return (
		<PageLayout>
			<Route
				path={matchedRoute.path}
				exact
				render={() => (
					<Screen
						userRights={matchedRoute.menuObj}
						token={userToken}
						{...(matchedRoute.path === "/sales-target-report-saleperson" ? modalValue : {})}
					/>)}
			/>
		</PageLayout>
	);
}